import { RouteName } from "constant/routeNames";
import { decodeHtmlEntities } from "constant/htmlEntities";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { addMusicToPlayer } from "redux/AudioPlayerRedux";
import CreatePlaylistIcon from "../audioPlayer/AudioPlayer3/CreatePlaylistIcon/CreatePlaylistIcon";
import AddSongToFav from "./AddSongToFav";
import AddSongToQueue from "./AddSongToQueue";
import TableRowImage from "./TableRowImage";
import { formatDuration } from "utils/timeFunctions";
import { TbTrashX } from "react-icons/tb";
import DeleteSongFromPlaylist from "./DeleteSongFromPlaylist";
import { Tooltip as ReactTooltip } from "react-tooltip";

function MusicTableTow({
  id,
  data,
  user,
  favorite,
  playlistId,
  userPlaylists,
  setUserPlaylists,
  removeFromPlaylist,
  setRemovedSongId,
}: any) {
  const dispatch = useDispatch<any>();
  const loggedInUser = useSelector((state: any) => state?.user?.currentUser);

  const handleMusicPlayer = () => {
    dispatch(addMusicToPlayer(data));
  };

  const [hover, setHover] = useState<boolean>(false);

  return (
    <>
      <tr
        className={`group relative cursor-pointer rounded-lg text-white transition-colors duration-200 ease-in-out hover:bg-white/[0.05] max-sm:w-full ${
          hover ? "hovered" : ""
        }`}
        onMouseEnter={() => setHover(true)}
        onMouseLeave={() => setHover(false)}
      >
        <td className="w-[5%] rounded-l-lg pl-3 max-sm:pl-0">
          <p className="text-[15px] text-[#626A66] group-hover:text-white/80">
            {id}
          </p>
        </td>
        <td className="w-[35%]">
          <div className="flex w-full items-center gap-4 py-2.5">
            <TableRowImage
              executionFunc={handleMusicPlayer}
              imgSrc={data?.artwork_url}
              imgAlt={"song"}
              imgHeight={"50px"}
              imgWidth={"50px"}
              hover={hover}
            />
            <div className="flex w-[70%]">
              <Link to={RouteName.MusicTrackRoute.replace(":id", data.id)}>
                <p
                  className="w-full text-[15px] text-[#AFB6B2] transition-colors group-hover:text-white max-sm:text-[10px]"
                  data-tooltip-id={
                    data?.title?.length > 30
                      ? `music-album-track-${data?.title}`
                      : ""
                  }
                >
                  {decodeHtmlEntities(data?.title)}
                </p>
                <div className="z-50 text-sm">
                  <ReactTooltip
                    id={`music-album-track-${data?.title}`}
                    place="top"
                    content={data?.title}
                    style={{ width: "200px" }}
                  />
                </div>
              </Link>
            </div>
          </div>
        </td>
        <td className="ml-2 w-[25%] items-center max-sm:text-[10px]">
          <Link
            to={RouteName.VideoCreatorHomeRoute.replace(
              ":slug",
              `@${data?.artists?.[0]?.slug}`
            )}
          >
            <p className="text-[15px] text-white/80 transition-colors hover:text-[var(--red)] hover:underline max-sm:text-[10px]">
              {decodeHtmlEntities(data?.artists?.[0]?.name)}
            </p>
          </Link>
        </td>
        <td className="w-[25%] items-center max-sm:mx-auto max-sm:w-[10%] max-sm:pl-1">
          <p className="text-[12px] text-[#7B9DB4] max-sm:text-[10px]">
            {formatDuration(data?.duration)}
          </p>
        </td>
        <td className="w-[10%] items-center justify-between rounded-r-lg max-sm:ml-[-20px]">
          <div className="flex items-center justify-end gap-5 pr-10 text-xl max-sm:gap-1">
            {loggedInUser &&
              (user ? (
                <>
                  {loggedInUser && user?.id === loggedInUser?.id && (
                    <AddSongToFav song={data} favorite={favorite} />
                  )}
                </>
              ) : (
                <>
                  <AddSongToFav song={data} favorite={favorite} />
                </>
              ))}

            <AddSongToQueue song={data} />
            {loggedInUser && (
              <>
                <DeleteSongFromPlaylist
                  mediaId={data.id}
                  setRemovedSongId={setRemovedSongId}
                  userPlaylists={userPlaylists}
                  removeFromPlaylist={removeFromPlaylist}
                  selectedPlaylistId={playlistId}
                />
              </>
            )}

            <div>
              <CreatePlaylistIcon
                userPlaylists={userPlaylists}
                setUserPlaylists={setUserPlaylists}
                mediaId={data.id}
                removeFromPlaylist={removeFromPlaylist}
                setRemovedSongId={setRemovedSongId}
              />
            </div>
          </div>
        </td>
      </tr>
    </>
  );
}

export default MusicTableTow;